import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsList from '../../../../../../components/newsList';

class ContentList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { newsContent0, newsContent1, newsContent2 },
        } = this.props;

        return (
            <div id="newsList" className={styles.content_list}>
                <Chip
                    id="75028"
                    type="recommend"
                    title="要闻区中栏要闻列表第一部分"
                    groupName="要闻区中栏"
                    translate="handleNewsContentData"
                    position="relative"
                    content={newsContent0}>
                    <NewsList hasTopic />
                </Chip>
                <Chip
                    id="75029"
                    type="recommend"
                    title="要闻区中栏要闻列表第二部分"
                    groupName="要闻区中栏"
                    translate="handleNewsData"
                    translateOptions={{ isHidden: newsContent2.isHidden }}
                    position="relative"
                    content={newsContent1}>
                    <NewsList />
                </Chip>
                <Chip
                    id="50098"
                    type="struct"
                    title="要闻区中栏要闻列表倒数第二条"
                    groupName="要闻区中栏"
                    position="relative"
                    content={newsContent2}>
                    <NewsList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(ContentList);
